import React, { useEffect, useState } from 'react'
import AutoImage from '../../AutoImage'
import { getProductPriceInfo } from '../../../utils/price'
import { isInSellingTime } from '../../../utils/bookRule'
import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp'
import CurrencySymbol from '../../CurrencySymbol'
import { getRecommendProductListModel, getAIRecommendedProductsModel } from '../../../model/store'
import PriceText from '../PriceText'
import ProductDesc from '../../ProductDesc'
import PackageDiscountBadge from '../../PackageDiscountBadge'

import styles from './index.module.less'
import { getLanguageStore } from '../../../utils/storage/language'
import { getMemberInfo } from '../../../utils/storage/store'
import { getSmartRecommendConfig } from '../../../utils/smartRecommend'

export default function RecommendProduct({
    list = [],
    events = {},
    fromApp = false,
    storeInfo,
    productIds,
    showOriginalPrice = true,
    readonly = false,
    actionC = '',
    addBehavior = false
}) {
    const [recommendList, setRecommendList] = useState([])
    const [aiRecommendedProducts, setAiRecommendedProducts] = useState([])
    const { renderProductActions, handleClickImageAction } = events

    const { productImages = '' } = storeInfo || {}
    const { memberId, registerLanguage } = getMemberInfo() || {}

    const loadAiRecommendedProducts = () => {
        if (getSmartRecommendConfig(storeInfo).top) {
            getAIRecommendedProductsModel({
                storeId: storeInfo?.storeId,
                memberId,
                recommendLang: registerLanguage,
                curLanguage: getLanguageStore(),
                productIdList: productIds
            }).then(res => {
                setAiRecommendedProducts(res)
            }).catch(err => {
                // console.log(err, '////===aiRecommendedProducts err===')
                setAiRecommendedProducts([])
            })
        } else {
            setAiRecommendedProducts([])
        }
    }

    useEffect(() => {
        if (fromApp) {
            getRecommendProductListModel({
                storeId: storeInfo?.storeId,
                pageSize: 10,
                pageNo: 1
            }).then(res => {
                const arr = res.filter(item => !productIds.includes(item.productId))
                console.log(arr, '////====res===')
                setRecommendList(arr)
            }).catch(err => {
                console.log(err, '////====err===')
            })
        }
    }, [fromApp, productIds])

    useEffect(() => {
        loadAiRecommendedProducts()
    }, [storeInfo, memberId])

    const isAiRecommendedProduct = aiRecommendedProducts.length > 0;
    const arr = isAiRecommendedProduct ? aiRecommendedProducts : (recommendList.length > 0 ? recommendList : list)
    if (arr.length === 0) return null
    return (
        <div className={styles.hotProductWrapper}>
            <ul className={`${styles.recomProductList} jm-scrollx-box`} style={{ gap: 10 }}>
                {
                    arr.map((item, index) => {
                        if(isAiRecommendedProduct){
                            item.isSmartRecommend = true;
                        }
                        const { amount, oriAmount } = getProductPriceInfo(item)
                        const inSellingTime = isInSellingTime(item)
                        return <li
                            key={index}
                            className={`jm-scroll-item1 hot-product-item ${styles.productItem}`}>

                            <div className={styles.productImg} onClick={() => {

                                handleClickImageAction(item)
                                addBehaviorsRecord({
                                    behaviorType: 160200,
                                    behavior: 160206,
                                    storeId: storeInfo.storeId,
                                    value1: item.productId,
                                    value2: 'recommend'
                                })
                            }}>
                                <AutoImage
                                    src={item.images || productImages}
                                    alt={item.productName}
                                    storeInfo={storeInfo}
                                />
                                <PackageDiscountBadge product={item} />
                            </div>
                            <div className={styles.actionBox}>
                                <div style={{ height: 50 }}>&nbsp;</div>
                                <div className='jm-flex' style={{ alignItems: 'flex-start' }}>
                                    <div className='jm-flex-item' style={{ width: 92 }}>
                                        <div className={`${styles.productName} ellips_line2`}>
                                            {item.productName || item.name}
                                        </div>
                                        {
                                            actionC !== 1 && (
                                                <div className={`${styles.productDesc}`}>
                                                    <ProductDesc list={item.description} ellipsis={true} />
                                                </div>
                                            )
                                        }

                                    </div>

                                    <div
                                        className={styles.productAction}
                                        style={{ height: actionC === 1 ? 40 : null }}
                                    >
                                        {!readonly && inSellingTime && renderProductActions({
                                            item,
                                            cls: styles.productNum,
                                            stepperOption: {
                                                iconColor: '#ffc53b',
                                                labelColor: '#fff',
                                                flexDirection: 'column',
                                                flexFlow: 'column-reverse'
                                            },
                                            addBehavior: true
                                        })}
                                    </div>
                                </div>

                                <div className={styles.productPriceWrapper}>
                                    <div className={styles.productPrice}>
                                        <span>
                                            <PriceText product={item} />
                                        </span>
                                        &nbsp;
                                        {
                                            (oriAmount > amount && showOriginalPrice) && <span className={styles.oriPrice}><CurrencySymbol currency={item.currency} />{oriAmount}</span>
                                        }
                                    </div>
                                </div>
                            </div>


                        </li>
                    })
                }
            </ul>

        </div>
    )
}
